export default "__VITE_ASSET__DTgVoDjP__"